import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { voices } from "@/mocks/home";

export default function Voices() {
  const [liked, setLiked] = useState<Record<string, boolean>>({});
  const [draft, setDraft] = useState("");
  const [notice, setNotice] = useState("");

  const toggleLike = (id: string) => {
    setLiked((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handlePost = () => {
    if (!draft.trim()) {
      setNotice("先写下你的观点，再点击发布。");
      return;
    }
    setNotice("本页为展示页面，观点暂不会真实发布。正式上线后即可参与互动。");
    setDraft("");
  };

  return (
    <section id="voices" className="bg-background-50 scroll-mt-20">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="Community Voices"
          title="网友观点 · 犀利也讲道理"
          description="同一条热点下，把不同立场的评论并排放在一起。支持你也反驳你，重要的是把话说清楚。"
          accent="secondary"
        />

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3">
          {voices.map((voice) => (
            <article
              key={voice.id}
              className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-secondary-200 md:p-5"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-500 font-heading text-base font-bold text-background-50">
                  {voice.initial}
                </span>
                <div className="min-w-0">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="truncate text-sm font-medium text-foreground-900">
                      {voice.name}
                    </span>
                    <span className="rounded-full bg-background-200 px-2 py-0.5 text-[11px] text-foreground-600">
                      {voice.role}
                    </span>
                  </div>
                  <span className="text-xs text-foreground-500">{voice.time}</span>
                </div>
              </div>

              <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                {voice.content}
              </p>

              <div className="mt-4 flex items-center gap-5 border-t border-background-200 pt-3 text-xs text-foreground-500">
                <button
                  type="button"
                  onClick={() => toggleLike(voice.id)}
                  className={`flex items-center gap-1.5 whitespace-nowrap transition-colors ${
                    liked[voice.id] ? "text-primary-600" : "hover:text-primary-600"
                  }`}
                >
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i
                      className={liked[voice.id] ? "ri-heart-fill text-sm" : "ri-heart-line text-sm"}
                    />
                  </span>
                  {(voice.likes + (liked[voice.id] ? 1 : 0)).toLocaleString()}
                </button>
                <span className="flex items-center gap-1.5">
                  <span className="flex h-4 w-4 items-center justify-center">
                    <i className="ri-chat-1-line text-sm" />
                  </span>
                  {voice.replies} 条回复
                </span>
                <button
                  type="button"
                  className="ml-auto flex items-center gap-1 whitespace-nowrap text-foreground-600 transition-colors hover:text-secondary-700"
                >
                  <i className="ri-share-forward-line text-sm" />
                  转发
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-4 md:p-6">
          <h3 className="font-heading text-base font-bold text-foreground-950">
            说说你的看法
          </h3>
          <p className="mt-1 text-sm text-foreground-600">
            对当前热点有不同角度？写下来，让讨论多一个立场。
          </p>
          <textarea
            name="opinion"
            value={draft}
            onChange={(event) => setDraft(event.target.value.slice(0, 500))}
            maxLength={500}
            rows={4}
            placeholder="描述你看到的事实，再说说你的判断……"
            className="mt-4 w-full resize-none rounded-md border border-background-300 bg-background-50 p-3 text-sm text-foreground-900 placeholder:text-foreground-500 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-400/30"
          />
          <div className="mt-3 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <span className="text-xs text-foreground-500">{draft.length} / 500 字</span>
            <button
              type="button"
              onClick={handlePost}
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              发布观点
            </button>
          </div>
          {notice ? <p className="mt-3 text-xs text-primary-600">{notice}</p> : null}
        </div>
      </div>
    </section>
  );
}